import Navbar from "@/components/NavBar";
import Footer from "@/components/Footer";
import React from "react";
import {usePathname} from "next/navigation";


interface MainLayoutProps {
    children: React.ReactNode;
}



export default function MainLayout({ children }: MainLayoutProps) {
    const pathname = usePathname();
    const showEllipse = pathname?.includes("rent-to-buy") || pathname?.includes("concessionari");
    return (
        <div className={`${showEllipse ? 'relative w-full overflow-hidden' : ''}`}>
            {showEllipse && (
                <>
                    <div
                        className="absolute top-0 left-0 w-full h-[100px] z-[-2]"
                        style={{ background: '#2d3cc1' }}
                    />

                    <div
                        className="w-[110%] h-[500px] max-sm:w-[160%] max-sm:h-[350px] absolute top-[0px] z-[-1] left-1/2 -translate-x-1/2"
                        style={{
                            background: "radial-gradient(50% 50% at 50% 50%, #5868FF 0%, #2D3CC1 100%)",
                            borderBottomLeftRadius: "50%",
                            borderBottomRightRadius: "50%",
                        }}
                    />
                </>
            )}
            <Navbar showEllipse={showEllipse} />
            <main className="min-h-screen mt-[140px]">
                {children}
            </main>
            <Footer />
        </div>
    );
}


/*
{showEllipse && (
                <>
                    <div
                        className="absolute top-0 left-0 w-full h-[100px] z-[-2]"
                        style={{ background: '#2d3cc1' }}
                    />

                    <div
                        className="absolute top-[0px] z-[-1] left-1/2 -translate-x-1/2"
                        style={{
                            width: "110%", // aumenta la larghezza oltre il container
                            height: "500px",
                            background: "radial-gradient(50% 50% at 50% 50%, #5868FF 0%, #2D3CC1 100%)",
                            borderBottomLeftRadius: "50%",
                            borderBottomRightRadius: "50%",
                        }}
                    />
                </>
            )}

*/
